<template>
  <div id="cc-progress" :style="[styleWrap,{'border-radius':borderRadius}]">
    <div class="progress-color" :style="progressStyle">
      <span
        class="progress-text-count"
        :style="{
          left:`${cpmLeft(num)}rem`
        }"
        v-if="showProgressCount"
      >{{ num }}%</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CcProgress',
  props: {
    total: {
      type: Number,
      default: 9999999
    },
    num: {
      type: Number,
      default: 0
    },
    styleWrap: {
      type: Object,
      default: () => {
        return {
          height: '20px',
          width: '100%',
          'background-color': '#383451'
        }
      }
    },
    borderRadius: {
      default: '5px'
    },
    color: {
      default: 'red'
    },
    showProgressCount: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      progressStyle: {
        'border-radius': '5px',
        width: '50%'
      }
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    // setTimeout(() => {
    //   this.progressStyle.width = '60%'
    // }, 2000)
  },
  watch: {
    borderRadius: {
      handler: function (newValue) {
        this.progressStyle['border-radius'] = newValue
      },
      immediate: true
    },
    color: {
      handler: function (newValue) {
        this.progressStyle['background'] = newValue
      },
      immediate: true
    },
    num: {
      handler: function (newValue) {
        if (+newValue < 0) { newValue = 0 }
        this.progressStyle.width = `${newValue}%`
      },
      immediate: true
    }
  },
  methods: {
    cpmLeft (number) {
      if (number >= 15) {
        return 0
      }
      let result = 1.3 - (number > 1 ? number : 0)
      return result > 0 ? result : 0
    }
  },
  components: {

  }
}
</script>

<style scoped lang="stylus">
#cc-progress
  overflow hidden
.progress-color
  height 100%
  transition: width 0.3s
  display flex
  justify-content: center
  align-items: center
  .progress-text-count
    position: relative
</style>
